import {
    CHECKOUT,
    DELIVERY_SEARCH,
    PROFILE,
    PROFILE_CUMULUS_PRODUCTS,
    PROFILE_ORDERS,
    PROFILE_ORDERS_DETAIL,
} from './page-names';

// these pages require the user to be logged in order to see them
export default [
    PROFILE,
    PROFILE_ORDERS,
    PROFILE_CUMULUS_PRODUCTS,
    PROFILE_ORDERS_DETAIL,
    DELIVERY_SEARCH,
    CHECKOUT,
];



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/protected-pages.js